export const mergeRefs =
  (...refs) =>
  node =>
    refs.forEach(ref =>
      typeof ref === "function" ? ref(node) : (ref.current = node)
    );
